<template>
    <v-row class="white pl-3 pr-3 ml-0 mr-0 pb-5 campo-input-edit">
        <v-col cols="12">
            <v-card flat class="documentos">
                <v-expansion-panels active-class="" flat>
                    <v-expansion-panel>
                        <v-expansion-panel-header @click="abrirPanelDocumentos" class="documentos-panel-header">
                            <h4 class="session-title">Documentos ({{ numeroDeDocumentosFormatado }})</h4>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content class="documentos-panel-header" eager>
                            <Documentos
                                ref="Documentos"
                                id="listagemTabela"
                                style="background-color: white !important;"
                                :donoDocumento="donoDocumento"
                                :donoDocumentoId="donoDocumentoId"
                                desabilitaAlturaMaxima
                                @updateNumeroDeDocumentos="(param) => this.numeroDeDocumentos = param"
                            />
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import Documentos from '@/views/components/documento/Documentos'

    export default {
        name: 'PanelDocumentos',

        components: {
            Documentos,
        },

        data() {
            return {
                numeroDeDocumentos: 0,
            }
        },

        props: {
            donoDocumento: {
                type: String,
                required: true
            },
            donoDocumentoId: {
                required: true
            }
        },

        computed: {
            numeroDeDocumentosFormatado() {
                const qtdString = this.numeroDeDocumentos.toString()
                return qtdString.length > 1 ? qtdString : '0' + qtdString
            }
        },

        methods: {
            abrirPanelDocumentos() {
                setTimeout(() => {
                    let options = {duration: 945, offset: -1, easing: 'linear',}
                    this.$vuetify.goTo('#listagemTabela', options)
                }, 250)
            },
            async atualizarDocumentos(){
                await this.$refs.Documentos.buscarListaDocumentos()
            }
        }
    }
</script>

<style lang="stylus">
    .documentos-panel-header .v-expansion-panel-content__wrap
        padding 0 10px 16px !important
</style>

<style lang="stylus" scoped>
    .session-title
        font-size 15px
        font-weight bold
        color #777 !important

    .documentos
        border solid 1px #e7e7e7 !important
        border-radius 5px !important
        box-shadow none

    .documentos-panel-header
        border-bottom solid 1px #e7e7e7 !important
        background-color white
        border-radius 5px !important
        min-height 20px !important
        padding-bottom 10px
        padding-top 10px

    .campo-input-edit
        .v-text-field
            .v-label
                color #777 !important
                font-weight bold
                font-size 13px
                overflow unset
                pointer-events auto
                top 0

            input:-webkit-autofill
                background-color white !important

            input
                font-size 13px
                color #888 !important

            .v-label--active
                -webkit-transform translateY(-18px)
                transform translateY(-18px)

            .v-select__selection--comma
                font-size 13px
                color #888 !important
</style>
